export default __webpack_public_path__ + "static/media/nexa.3e9fb638.webp";